var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "CardBodyItem",
    {
      attrs: {
        label: _vm.label,
        additionalClass: "sidebarTtile",
        textStyleClasses: "chipLabel",
        labelClass: _vm.initialLabel,
        text: "",
        wide: "",
      },
    },
    [
      _vm.noContent
        ? _c("span", { class: _vm.noContentClasses }, [
            _vm._v(" " + _vm._s(_vm.noContentPlaceholder) + " "),
          ])
        : _c("ItemChip", {
            attrs: {
              textClasses: _vm.labelStyle,
              avatarColor: _vm.newAvatarColor,
              adjustGap: _vm.adjustGap,
              maxChipWidth: _vm.customContainerClass,
              hideBorder: true,
              backGround: _vm.background,
              itemId: _vm.chipDetails.id,
              itemName: _vm.chipDetails.name,
              itemRole: _vm.chipDetails.role,
              avatar: _vm.chipDetails.avatar,
              routeParams: _vm.chipDetails.routeParams,
              isPerson: _vm.withAvatar,
              single: "",
            },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }